module.exports = __webpack_public_path__ + "img/logo_bn.8f1cd490.png";